import api from "../axiosInstance";

export async function changePassword(payload) {
  // payload: { email, oldPassword, newPassword }
  const resp = await api.post("/auth/change-password", payload);
  return resp.data;
}

export async function forgotPassword(payload) {
  // payload: { email }
  const resp = await api.post("/auth/forgot-password", payload);
  return resp.data;
}

export async function resetPassword(payload) {
  // payload: { token, newPassword }
  const resp = await api.post("/auth/reset-password", payload);
  return resp.data;
}


